import React, { useEffect, useState } from 'react';
import { Grid, Hidden, Typography } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import Controls from '../../components/controls/Controls';
import { useForm, Form } from '../../components/useForm';
import {
  getLibRessource,
  getIdRessource,
  getPublicCible,
  getTypeAffectation,
  getCategorieAffectation,
} from '../../utils/subscriptionsService';

const typeLicencesItems = [
  { id: 'nbLGlb', title: 'Global', disabled: false },
  { id: 'nbLDetailed', title: 'Détaillé', disabled: false },
];

const initialFValues = {
  idAbonnement: '',
  typeLicences: 'nbLGlb',
  idDistributeurCom: '',
  idRessource: '',
  uaiEtab: '',
  commentaireAbonnement: '',
  typeIdRessource: 'ark',
  libelleRessource: '',
  categorieAffectation: 'transferable',
  typeAffectation: 'INDIV',
  debutValidite: new Date(`${new Date().getFullYear()} 09 01`),
  finValidite: new Date(`${new Date().getFullYear() + 1} 08 15`),
  anneeDebut: new Date(),
  anneeFin: new Date(`${new Date().getFullYear() + 1}`),
  anneeFinValidite: `${new Date().getFullYear()}-${
    new Date().getFullYear() + 1
  }`,
  nbLicenceGlobale: '',
  nbLicenceEleve: 0,
  nbLicenceEnseignant: 0,
  nbLicenceProfDoc: 0,
  nbLicenceAutrePersonnel: 0,
  publicCible: [],
  anneeScolaire: true,
  nbAllLicences: '',
  codeProjetRessource: '',
};

export default function SubscriptionsForm({
  addOrEdit,
  recordForEdit,
  resources,
  isILLIMITE,
}) {
  const [error, setError] = useState(false);
  const [libRessource, setLibRessource] = useState('');

  const validate = (fieldValues = values) => {
    let temp = { ...errors };
    values.anneeFinValidite = `${values.anneeDebut.getFullYear()}-${
      values.anneeDebut.getFullYear() + 1
    }`;

    // Composition de l'idAbonnement
    values.idAbonnement = recordForEdit
      ? values.idAbonnement
      : `${values.idRessource.split('/')[2]}_${Date.now()}`;

    // En ajoutant nbAllLicences, cela me permet de vérifier si l'un des 4 champs est vide juste en consultant la valeur de values.nbAllLicences
    values.nbAllLicences =
      +values.nbLicenceEleve +
      +values.nbLicenceEnseignant +
      +values.nbLicenceProfDoc +
      +values.nbLicenceAutrePersonnel;

    values.anneeDebut = new Date(values.anneeDebut.getFullYear(), 11, 31, 23);
    // ici je retransforme la string debutValidite & finValidite en Date pour la modification
    values.debutValidite = new Date(`${values.debutValidite}`);
    values.finValidite = new Date(`${values.finValidite}`);

    if ('uaiEtab' in fieldValues)
      temp.uaiEtab = fieldValues.uaiEtab ? '' : 'Ce champ est obligatoire';

    if (values.anneeScolaire) {
      if (values.anneeDebut < values.debutValidite) {
        if ('anneeDebut' in fieldValues) {
          temp.anneeDebut = 'Année debut est inférieure à la date de debut';
        }
      } else {
        if ('finValidite' in fieldValues) temp.finValidite = '';
        if ('anneeDebut' in fieldValues) temp.anneeDebut = '';
      }
      if (values.anneeDebut > values.anneeFin) {
        if ('anneeDebut' in fieldValues) {
          temp.anneeDebut =
            'Année debut scolaire doit être inférieure à année fin';
        }
      }
      if ('finValidite' in fieldValues) temp.finValidite = '';
    } else {
      if ('anneeDebut' in fieldValues) temp.anneeDebut = '';
      if (values.finValidite < values.debutValidite) {
        console.log(values.finValidite, 'ANNEE FIN');
        console.log(values.debutValidite, 'ANNEE DEB');
        if ('finValidite' in fieldValues) {
          temp.finValidite =
            'Date de fin doit être supérieure à la date de debut';
        }
      } else {
        console.log('HELP');
        if ('finValidite' in fieldValues) temp.finValidite = '';
      }
    }
    if (values.typeLicences === 'nbLGlb') {
      setError(false);
      temp.nbAllLicences = '';
      if ('nbLicenceGlobale' in fieldValues)
        temp.nbLicenceGlobale = fieldValues.nbLicenceGlobale
          ? ''
          : 'Ce champ est obligatoire';
      if ('publicCible' in fieldValues)
        temp.publicCible =
          fieldValues.publicCible.length !== 0
            ? ''
            : 'Choisissez au moins une cible';
    } else if (values.typeLicences === 'nbLDetailed') {
      setError(false);
      if (values.nbAllLicences <= 0 || values.nbAllLicences === '') {
        setError(true);
        if ('nbAllLicences' in fieldValues) {
          temp.nbAllLicences = +fieldValues.nbAllLicences
            ? ''
            : "Champ licences n'est pas renseigné";
        }
      }
      temp.nbLicenceGlobale = '';
      temp.publicCible = '';
    }
    if ('idRessource' in fieldValues)
      temp.idRessource = fieldValues.idRessource
        ? ''
        : 'Ce champ est obligatoire';
    if ('typeIdRessource' in fieldValues)
      temp.typeIdRessource = fieldValues.typeIdRessource
        ? ''
        : 'Ce champ est obligatoire';
    // if ('libelleRessource' in fieldValues)
    //   temp.libelleRessource = fieldValues.libelleRessource
    //     ? ''
    //     : 'Ce champ est obligatoire';
    setErrors({
      ...temp,
    });

    if (fieldValues === values)
      return Object.values(temp).every((val) => val === '');
  };

  const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
    useForm(initialFValues, true, validate);

  /**
   * Gestion des boutons radios lors de la modification
   */
  if (recordForEdit) {
    values.typeLicences === 'nbLGlb'
      ? (typeLicencesItems[1].disabled = true)
      : (typeLicencesItems[1].disabled = false);
    values.typeLicences === 'nbLDetailed'
      ? (typeLicencesItems[0].disabled = true)
      : (typeLicencesItems[0].disabled = false);
  } else {
    typeLicencesItems[0].disabled = false;
    typeLicencesItems[1].disabled = false;
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    values.libelleRessource = libRessource;
    if (validate()) {
      addOrEdit(values, resetForm);
    }
  };

  // Permet de setter le libelle ressource
  useEffect(() => {
    if (getLibRessource(resources, values.idRessource)) {
      setLibRessource(getLibRessource(resources, values.idRessource));
    }
  }, [resources, values.idRessource]);

  useEffect(() => {
    if (recordForEdit != null) {
      setValues({
        ...recordForEdit,
      });
    }
  }, [recordForEdit, setValues]);

  return (
    <Form onSubmit={handleSubmit}>
      <Grid container>
        <Grid item xs={6}>
          <Controls.Input
            disabled={recordForEdit ? true : false}
            name='uaiEtab'
            label='Code uai'
            value={values.uaiEtab}
            onChange={handleInputChange}
            error={errors.uaiEtab}
          />
          <Hidden xsUp>
            <Controls.Input
              name='nbAllLicences'
              label='All Licences'
              value={values.nbAllLicences}
              onChange={handleInputChange}
              error={errors.nbAllLicences}
            />
          </Hidden>
          <Controls.Input
            label='Commentaire'
            name='commentaireAbonnement'
            value={values.commentaireAbonnement}
            onChange={handleInputChange}
            error={errors.commentaireAbonnement}
          />
          <Controls.Select
            disabled={recordForEdit ? true : false}
            label='Id ressource'
            name='idRessource'
            value={values.idRessource}
            onChange={handleInputChange}
            options={getIdRessource(resources)}
            error={errors.idRessource}
          />
          <Controls.Input
            disabled
            label='Type ressource'
            name='typeIdRessource'
            value={values.typeIdRessource}
            onChange={handleInputChange}
            error={errors.typeIdRessource}
          />
          <Typography
            variant='caption'
            display='block'
            className='MuiFormControl-root MuiTextField-root'
            color='textSecondary'
          >
            Ce champ sera rempli automatiquement selon, l'id ressource.
          </Typography>
          <Controls.Input
            disabled
            label='Libellé'
            value={libRessource}
            error={errors.libelleRessource}
          />
          <Controls.DatePicker
            disabled={recordForEdit ? true : false}
            name='debutValidite'
            label='Debut'
            value={values.debutValidite}
            onChange={handleInputChange}
            error={errors.debutValidite}
          />
          <Controls.Checkbox
            name='anneeScolaire'
            label='Année scolaire'
            value={values.anneeScolaire}
            onChange={handleInputChange}
            error={errors.anneeScolaire}
          />
          {!values.anneeScolaire ? (
            <Controls.DatePicker
              name='finValidite'
              label='Fin'
              value={values.finValidite}
              onChange={handleInputChange}
              error={errors.finValidite}
            />
          ) : (
            <Grid container>
              <Grid item xs={5}>
                <Controls.DatePickerYear
                  name='anneeDebut'
                  label='Année debut'
                  value={values.anneeDebut}
                  onChange={handleInputChange}
                  error={errors.anneeDebut}
                />
              </Grid>
              <Grid item xs={5}>
                <Controls.DatePickerYear
                  name='anneeFin'
                  label='Année fin'
                  value={values.anneeFin}
                  onChange={handleInputChange}
                  error={errors.anneeFin}
                />
              </Grid>
            </Grid>
          )}
        </Grid>
        <Grid item xs={6}>
          <Controls.RadioGroup
            name='typeLicences'
            label='Nombre licences'
            value={values.typeLicences}
            onChange={handleInputChange}
            items={typeLicencesItems}
          />
          {values.typeLicences === 'nbLGlb' ? (
            <Controls.Input
              disabled={isILLIMITE ? true : false}
              label='Licence globale'
              name='nbLicenceGlobale'
              value={values.nbLicenceGlobale}
              onChange={handleInputChange}
              error={errors.nbLicenceGlobale}
            />
          ) : (
            <>
              {error ? (
                <Alert variant='outlined' severity='error'>
                  Au moins un champ licences n'est pas renseigné
                </Alert>
              ) : null}
              <Controls.Input
                label='Licence élève'
                name='nbLicenceEleve'
                value={values.nbLicenceEleve}
                onChange={handleInputChange}
                error={errors.nbLicenceEleve}
              />
              <Controls.Input
                label='Licence enseignant'
                name='nbLicenceEnseignant'
                value={values.nbLicenceEnseignant}
                onChange={handleInputChange}
                error={errors.nbLicenceEnseignant}
              />
              <Controls.Input
                label='Licence documentaliste'
                name='nbLicenceProfDoc'
                value={values.nbLicenceProfDoc}
                onChange={handleInputChange}
                error={errors.nbLicenceProfDoc}
              />
              <Controls.Input
                label='Licence autres personnel'
                name='nbLicenceAutrePersonnel'
                value={values.nbLicenceAutrePersonnel}
                onChange={handleInputChange}
                error={errors.nbLicenceAutrePersonnel}
              />
            </>
          )}
          <Controls.Select
            disabled={recordForEdit ? true : false}
            name='typeAffectation'
            label='Type affectation'
            value={values.typeAffectation}
            onChange={handleInputChange}
            options={getTypeAffectation()}
            error={errors.typeAffectation}
          />
          <Controls.Select
            disabled={recordForEdit ? true : false}
            name='categorieAffectation'
            label='Catégorie affectation'
            value={values.categorieAffectation}
            onChange={handleInputChange}
            options={getCategorieAffectation()}
            error={errors.categorieAffectation}
          />
          <Controls.MultipleSelect
            name='publicCible'
            label='Public cible'
            value={values.publicCible}
            onChange={handleInputChange}
            options={getPublicCible()}
            error={errors.publicCible}
          />
          <Controls.Input
            label='Code projet ressource'
            name='codeProjetRessource'
            value={values.codeProjetRessource}
            onChange={handleInputChange}
            error={errors.codeProjetRessource}
          />
          <div>
            <Controls.Button type='submit' text='Envoyer' />
            {/* <Controls.Button
              text='réinitialiser'
              color='default'
              onClick={resetForm}
            /> */}
          </div>
        </Grid>
      </Grid>
    </Form>
  );
}
